export default {
  namespaced: true,

  state: {
    language: localStorage.getItem("language") || "th",
    previousRoute: null ,
    routeLoading:false
  },

  mutations: {
    SET_LANGUAGE(state, language) {
      state.language = language;
      localStorage.setItem("language", language);
    },
    SET_PREVIOUS_ROUTE(state, route) { 
      state.previousRoute = route;
    },
    SET_ROUTE_LOADING(state,status){
      state.routeLoading = status
    }
  },

  actions: {
    updateLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    updatePreviousRoute({ commit }, route) {
      commit("SET_PREVIOUS_ROUTE", route);
    }
  },

  getters: {
    currentLanguage: (state) => state.language,
    previousRoute: (state) => state.previousRoute,
    isLoading: (state) => state.routeLoading,
  }
};